import type { ReactNode } from 'react';
import { useAuthStore } from '@shared/stores/authStore';
import { NotificationOnboarding } from './NotificationOnboarding';

export function NotificationOnboardingGate({ children }: { children: ReactNode }) {
  const user = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const impersonating = useAuthStore((state) => state.isImpersonating);
  const scope = useAuthStore((state) => state.getAuthorizationScope());
  if (token && user?.notification_preferences_configured === false && !impersonating) {
    return <NotificationOnboarding key={scope} />;
  }
  return children;
}
